class VivaCheckout {
    constructor() {
        this.apiEndpoint = "/web2/start_registration.php";
        this.maxRetries = 3;
        this.retryDelay = 1000;
        this.requestInProgress = false;
        this.lastRequestTime = 0;
        this.minRequestInterval = 2000;

        this.validPackages = [
            "backfit",
            "sportsrecover",
            "nutrition",
            "adipocare",
            "neuro",
            "pelvis",
            "joints",
        ];
        this.validLanguages = [
            "bg-BG",
            "hr-HR",
            "cs-CZ",
            "da-DK",
            "nl-NL",
            "nl-BE",
            "en-GB",
            "en-US",
            "fi-FI",
            "fr-BE",
            "fr-FR",
            "de-DE",
            "el-GR",
            "hu-HU",
            "it-IT",
            "pl-PL",
            "pt-PT",
            "ro-RO",
            "ru-RU",
            "es-ES",
            "sv-SE",
        ];

        // Package details for display
        this.packageDetails = {
            backfit: {
                name: {
                    de: "BackFit - Rückenschmerzen & Wirbelsäulenbehandlung",
                    en: "BackFit - Back Pain & Spine Care",
                },
                price: "$30.00",
            },
            sportsrecover: {
                name: {
                    de: "SportsRecover - Rehabilitation bei Sportverletzungen",
                    en: "SportsRecover - Sports Injury & Performance Rehab",
                },
                price: "$30.00",
            },
            nutrition: {
                name: {
                    de: "Ernährung & Lebensstil",
                    en: "Nutrition & Lifestyle Program",
                },
                price: "$30.00",
            },
            adipocare: {
                name: {
                    de: "AdipoCare - Programm zur Behandlung von Fettleibigkeit",
                    en: "AdipoCare - Obesity & Weight Management",
                },
                price: "$30.00",
            },
            neuro: {
                name: {
                    de: "Neuro & Schlaganfall - Digitale Neurorehabilitation",
                    en: "Neuro & Stroke - Digital Neurorehabilitation",
                },
                price: "$30.00",
            },
            pelvis: {
                name: {
                    de: "PelvisHealth - Beckenboden & Lebensqualität",
                    en: "PelvicHealth - Pelvic Floor & Quality of Life",
                },
                price: "$30.00",
            },
            joints: {
                name: {
                    de: "JointFit - Knie- & Hüftgesundheit",
                    en: "JointFit - Knee & Hip Health",
                },
                price: "$30.00",
            },
        };

        this.currentPackage = null;
        this.modal = null;

        this.init();
    }

    init() {
        this.setupModal();
        this.setupEventListeners();
        this.initializeBirthdateInput();
    }

    setupModal() {
        this.modal = new Modal("checkoutModal", {
            onOpen: () => {
                this.updateModalContent();
                this.modal.focusFirstInput();
            },
            onClose: () => {
                this.resetForm();
            },
        });

        const form = document.getElementById("checkoutForm");
        if (form) {
            form.addEventListener("submit", (e) => this.handleFormSubmit(e));
        }
    }

    setupEventListeners() {
        // Add click handlers to all checkout buttons with data-package attribute
        document.querySelectorAll("[data-package]").forEach((button) => {
            button.addEventListener("click", (e) =>
                this.handleCheckoutButtonClick(e),
            );
        });
    }

    handleCheckoutButtonClick(e) {
        e.preventDefault();

        const button = e.currentTarget;
        const packageType = button.dataset.package;

        const validatedPackage = this.validatePackage(packageType);
        if (!validatedPackage) {
            this.showError(
                "Invalid package selected. Please refresh the page and try again.",
            );
            return;
        }

        this.currentPackage = validatedPackage;
        this.openModal();
    }

    openModal() {
        if (!this.currentPackage) return;
        this.modal.open();
    }

    closeModal() {
        this.modal.close();
    }

    updateModalContent() {
        if (!this.currentPackage || !this.packageDetails[this.currentPackage])
            return;

        const lang = document.documentElement.lang || "en";
        const packageInfo = this.packageDetails[this.currentPackage];

        // Update package name
        const nameElement = document.getElementById("selectedPackageName");
        if (nameElement) {
            nameElement.textContent =
                packageInfo.name[lang] || packageInfo.name.en;
        }

        // Update package price
        const priceElement = document.getElementById("selectedPackagePrice");
        if (priceElement) {
            priceElement.textContent = packageInfo.price;
        }
    }

    resetForm() {
        const form = document.getElementById("checkoutForm");
        if (form) {
            form.reset();
        }

        // Clear any error messages
        document.querySelectorAll(".input-error").forEach((el) => {
            el.classList.remove("input-error");
        });
        document.querySelectorAll(".input-error-message").forEach((el) => {
            el.remove();
        });

        this.currentPackage = null;
    }

    initializeBirthdateInput() {
        const birthdateInput = document.getElementById("customer-birthdate");
        if (!birthdateInput) return;

        // Set max date to 18 years ago
        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() - 18);
        birthdateInput.max = maxDate.toISOString().split("T")[0];

        // Set min date to 120 years ago
        const minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 120);
        birthdateInput.min = minDate.toISOString().split("T")[0];

        // Add real-time validation
        birthdateInput.addEventListener("blur", (e) => {
            this.validateBirthdateInput(e.target);
        });

        birthdateInput.addEventListener("change", (e) => {
            this.validateBirthdateInput(e.target);
        });

        // Email confirmation validation
        const emailInput = document.getElementById("customer-email");
        const emailConfirmInput = document.getElementById(
            "customer-email-confirm",
        );

        if (emailConfirmInput) {
            emailConfirmInput.addEventListener("blur", () => {
                this.validateEmailMatch();
            });

            emailConfirmInput.addEventListener("input", () => {
                // Clear error on typing if emails match
                if (
                    emailInput &&
                    emailInput.value === emailConfirmInput.value
                ) {
                    this.clearInputError(emailConfirmInput);
                }
            });
        }

        if (emailInput) {
            emailInput.addEventListener("input", () => {
                // Clear confirmation error when changing primary email
                if (emailConfirmInput) {
                    this.clearInputError(emailConfirmInput);
                }
            });
        }
    }

    validateBirthdateInput(input) {
        const value = input.value;
        if (!value) {
            this.showInputError(input, "Birthdate is required");
            return false;
        }

        const date = new Date(value);
        const now = new Date();
        const age = now.getFullYear() - date.getFullYear();
        const monthDiff = now.getMonth() - date.getMonth();

        let adjustedAge = age;
        if (
            monthDiff < 0 ||
            (monthDiff === 0 && now.getDate() < date.getDate())
        ) {
            adjustedAge--;
        }

        if (adjustedAge < 18) {
            this.showInputError(input, "You must be at least 18 years old");
            return false;
        }

        if (adjustedAge > 120) {
            this.showInputError(input, "Please enter a valid birthdate");
            return false;
        }

        this.clearInputError(input);
        return true;
    }

    validateEmailMatch() {
        const emailInput = document.getElementById("customer-email");
        const emailConfirmInput = document.getElementById(
            "customer-email-confirm",
        );

        if (!emailInput || !emailConfirmInput) return true;

        const email = emailInput.value.trim();
        const emailConfirm = emailConfirmInput.value.trim();

        if (!emailConfirm) {
            this.showInputError(
                emailConfirmInput,
                "Please confirm your email address",
            );
            return false;
        }

        if (email !== emailConfirm) {
            this.showInputError(
                emailConfirmInput,
                "Email addresses do not match",
            );
            return false;
        }

        this.clearInputError(emailConfirmInput);
        return true;
    }

    showInputError(input, message) {
        this.clearInputError(input);

        input.classList.add("input-error");
        const errorDiv = document.createElement("div");
        errorDiv.className = "input-error-message";
        errorDiv.textContent = message;
        input.parentNode.appendChild(errorDiv);
    }

    clearInputError(input) {
        input.classList.remove("input-error");
        const existingError = input.parentNode.querySelector(
            ".input-error-message",
        );
        if (existingError) {
            existingError.remove();
        }
    }

    async handleFormSubmit(e) {
        e.preventDefault();

        if (this.requestInProgress) {
            console.log("Request already in progress");
            return;
        }

        const rateCheck = this.canMakeRequest();
        if (!rateCheck.allowed) {
            this.showError(
                `Please wait ${rateCheck.waitTime} seconds before trying again.`,
            );
            return;
        }

        if (!this.currentPackage) {
            this.showError("No package selected. Please try again.");
            return;
        }

        // Validate email match
        if (!this.validateEmailMatch()) {
            const emailConfirmInput = document.getElementById(
                "customer-email-confirm",
            );
            if (emailConfirmInput) {
                emailConfirmInput.focus();
            }
            return;
        }

        // Validate all inputs
        const customerData = this.getCustomerData();

        if (!customerData.birthdate) {
            const birthdateInput =
                document.getElementById("customer-birthdate");
            if (birthdateInput) {
                birthdateInput.focus();
                this.showInputError(birthdateInput, "Birthdate is required");
            }
            return;
        }

        const submitBtn = document.getElementById("checkoutSubmitBtn");
        const originalText = submitBtn.innerHTML;

        submitBtn.disabled = true;
        submitBtn.classList.add("is-loading");
        submitBtn.innerHTML = '<span class="loading-spinner"></span>';

        this.requestInProgress = true;
        this.lastRequestTime = Date.now();

        try {
            const response = await this.createPaymentOrder(
                this.currentPackage,
                customerData,
            );

            if (response && response.success) {
                window.location.href = "/web2/confirmation_await.php";
            } else {
                const errorMsg =
                    response?.error || "Registration failed. Please try again.";
                throw new Error(errorMsg);
            }
        } catch (error) {
            console.error("Checkout error:", error);
            this.showError(
                error.message || "An error occurred. Please try again.",
            );

            submitBtn.disabled = false;
            submitBtn.classList.remove("is-loading");
            submitBtn.innerHTML = originalText;
            this.requestInProgress = false;
        }
    }

    // Validation methods
    validatePackage(packageName) {
        if (typeof packageName !== "string") return null;
        const sanitized = packageName.toLowerCase().trim();
        if (!this.validPackages.includes(sanitized)) {
            console.error("Invalid package name:", packageName);
            return null;
        }
        return sanitized;
    }

    validateEmail(email) {
        if (typeof email !== "string") return "";
        email = email.trim();
        const emailRegex =
            /^((?:[A-Za-z0-9!#$%&'*+\-\/=?^_`{|}~]|(?<=^|\.)"|"(?=$|\.|@)|(?<=".*)[ .](?=.*")|(?<!\.)\.){1,64})(@)((?:[A-Za-z0-9.\-])*(?:[A-Za-z0-9])\.(?:[A-Za-z0-9]){2,})$/gm;
        return emailRegex.test(email) ? email : "";
    }

    validateName(name) {
        if (typeof name !== "string") return "";
        name = name.replace(/<[^>]*>/g, "");
        name = name.replace(/[\x00-\x1F\x7F]/g, "");
        name = name.trim().substring(0, 100);
        const nameRegex = /^[a-zA-ZÀ-ÿ\s'-]+$/;
        return nameRegex.test(name) ? name : "";
    }

    validateCountryCode(code) {
        if (typeof code !== "string") return "EN";
        code = code.toUpperCase().trim();
        const countryRegex = /^[A-Z]{2}$/;
        return countryRegex.test(code) ? code : "EN";
    }

    validateLanguage(lang) {
        if (typeof lang !== "string") return "en-US";
        return this.validLanguages.includes(lang) ? lang : "en-US";
    }

    validateBirthdate(birthdate) {
        if (typeof birthdate !== "string") return "";
        if (!/^\d{4}-\d{2}-\d{2}$/.test(birthdate)) return "";

        const date = new Date(birthdate);
        if (isNaN(date.getTime())) return "";

        const now = new Date();
        const age = now.getFullYear() - date.getFullYear();
        const monthDiff = now.getMonth() - date.getMonth();

        let adjustedAge = age;
        if (
            monthDiff < 0 ||
            (monthDiff === 0 && now.getDate() < date.getDate())
        ) {
            adjustedAge--;
        }

        if (adjustedAge < 18 || adjustedAge > 120) return "";

        return birthdate;
    }

    validatePhone(phone) {
        if (typeof phone !== "string") return "";
        phone = phone.trim();

        phone = phone.replace(/[^\d+]/g, "");

        const phoneRegex = /^\+?[1-9]\d{6,14}$/;

        return phoneRegex.test(phone) ? phone : "";
    }

    canMakeRequest() {
        const now = Date.now();
        const timeSinceLastRequest = now - this.lastRequestTime;

        if (timeSinceLastRequest < this.minRequestInterval) {
            const waitTime = Math.ceil(
                (this.minRequestInterval - timeSinceLastRequest) / 1000,
            );
            return { allowed: false, waitTime };
        }

        return { allowed: true };
    }

    sanitizeResponse(data) {
        if (!data || typeof data !== "object") return null;

        const sanitized = {};

        if (data.success === true) {
            sanitized.success = true;
        } else {
            sanitized.success = false;
        }

        if (typeof data.error === "string") {
            sanitized.error = data.error
                .replace(/<[^>]*>/g, "")
                .substring(0, 200);
        }

        return sanitized;
    }

    async createPaymentOrder(packageType, customerData) {
        let lastError = null;

        for (let attempt = 0; attempt < this.maxRetries; attempt++) {
            try {
                const response = await fetch(this.apiEndpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        package: packageType,
                        customer: customerData,
                    }),
                    credentials: "same-origin",
                });

                if (!response.ok) {
                    if (response.status === 429) {
                        throw new Error(
                            "Too many requests. Please wait a moment and try again.",
                        );
                    }

                    if (response.status >= 500) {
                        throw new Error(
                            "Server error. Please try again later.",
                        );
                    }

                    const contentType = response.headers.get("content-type");
                    if (
                        contentType &&
                        contentType.includes("application/json")
                    ) {
                        const errorData = await response.json();
                        throw new Error(
                            errorData.error ||
                                `Request failed with status ${response.status}`,
                        );
                    }

                    throw new Error(
                        `Request failed with status ${response.status}`,
                    );
                }

                const contentType = response.headers.get("content-type");
                if (!contentType || !contentType.includes("application/json")) {
                    throw new Error("Invalid response format from server");
                }

                const data = await response.json();
                return this.sanitizeResponse(data);
            } catch (error) {
                lastError = error;
                console.error(`Attempt ${attempt + 1} failed:`, error);

                if (
                    error.message.includes("status 4") &&
                    !error.message.includes("429")
                ) {
                    break;
                }

                if (attempt < this.maxRetries - 1) {
                    await this.sleep(this.retryDelay * (attempt + 1));
                }
            }
        }

        throw (
            lastError ||
            new Error("Failed to create payment order after multiple attempts")
        );
    }

    getCustomerData() {
        const firstNameInput = document.getElementById("customer-firstname");
        const lastNameInput = document.getElementById("customer-lastname");
        const emailInput = document.getElementById("customer-email");
        const birthdateInput = document.getElementById("customer-birthdate");
        const phoneInput = document.getElementById("customer-phone");
        const langSelect = document.getElementById("customer-language");

        const requestLang = this.validateLanguage(langSelect?.value || "en-US");
        const countryCode = requestLang.slice(-2).toUpperCase();

        return {
            first_name: firstNameInput
                ? this.validateName(firstNameInput.value)
                : "",
            last_name: lastNameInput
                ? this.validateName(lastNameInput.value)
                : "",
            email: emailInput ? this.validateEmail(emailInput.value) : "",
            birthdate: birthdateInput
                ? this.validateBirthdate(birthdateInput.value)
                : "",
            phone: phoneInput 
                ? this.validatePhone(phoneInput.value) 
                : "",
            requestLang: requestLang,
            countryCode: countryCode,
        };
    }

    showError(message) {
        const sanitizedMessage = this.sanitizeErrorMessage(message);

        const errorDiv = document.createElement("div");
        errorDiv.className = "checkout-error";
        errorDiv.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #fee2e2;
      border: 2px solid #ef4444;
      color: #991b1b;
      padding: 16px 20px;
      border-radius: 8px;
      max-width: 400px;
      z-index: 10000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      font-family: inherit;
    `;

        errorDiv.textContent = sanitizedMessage;
        document.body.appendChild(errorDiv);

        setTimeout(() => {
            errorDiv.style.opacity = "0";
            errorDiv.style.transition = "opacity 0.3s";
            setTimeout(() => errorDiv.remove(), 300);
        }, 5000);

        console.error("Checkout error:", sanitizedMessage);
    }

    sanitizeErrorMessage(message) {
        if (typeof message !== "string") {
            return "An unexpected error occurred. Please try again.";
        }

        message = message.replace(/<[^>]*>/g, "");
        message = message.replace(/[\x00-\x1F\x7F]/g, "");
        message = message.trim().substring(0, 200);

        return message || "An error occurred. Please try again.";
    }

    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}

// Initialize checkout when DOM is ready
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        new VivaCheckout();
    });
} else {
    new VivaCheckout();
}
